
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'

export default {
  components: {
    RevButton,
  },
  props: {
    modalName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    openModal() {
      openModal(this.modalName)
    },
  },
}
